import React, { useState, useEffect } from "react";
import { animated } from "react-spring/three";
import { sRGBEncoding } from "three";
import useStore from "../modules/useStore";

export default function VideoText({ clicked, link, index, video: { url }, ...props }) {
  const { currentProject } = useStore(({ currentProject }) => ({ currentProject }))
  const [video] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: url || "/drei.mp4",
      crossOrigin: "Anonymous",
      loop: true,
      autoplay: true,
      muted: true,
    })
  );
  // useEffect(() => void (clicked && video.play()), [video, clicked]);
  useEffect(() => void (currentProject === index && clicked ? video.play?.() : video.pause?.()), [clicked, video, currentProject])
  return (
    <animated.mesh {...props} onClick={() => link && window.open(link)}>
      <planeGeometry args={[3 * 1.6, 3 * 0.9]}></planeGeometry>
      <meshBasicMaterial toneMapped={false} encoding={sRGBEncoding}>
        <videoTexture attach="map" args={[video]} encoding={sRGBEncoding} />
      </meshBasicMaterial>
    </animated.mesh>
  );
}
